import React, { useState } from "react";

import { getImageFromStory } from "app/utils";
import imagesSizes from "constants/imagesSizes";

import FacebookPreview from "./previews/FacebookPreview";
import InstagramPreview from "./previews/InstagramPreview";
import LinkedinPreview from "./previews/LinkedinPreview";
import TiktokPreview from "./previews/TiktokPreview";

const SocialMediaPreviewCard = ({ category, profile, shareMessage, story, username }) => {
  const mediaRef = React.createRef();
  const [showVideoInfo, setShowVideoInfo] = useState(false);
  const [imageUrl] = useState(story.media.mediaType === "image" ? getImageFromStory(imagesSizes.NORMAL, story) : story.media.thumbnail);

  const handlePlay = () => {
    mediaRef.current.play();
  };

  const handleShowVideoInfo = value => {
    setShowVideoInfo(value);
  };

  switch (category) {
    case "facebook":
      return (
        <div className="SocialMedia-Preview" key={category}>
          <FacebookPreview
            mediaRef={mediaRef}
            showVideoInfo={showVideoInfo}
            onShowVideoInfo={handleShowVideoInfo}
            onPlay={handlePlay}
            imageUrl={imageUrl}
            profile={profile}
            story={story}
            shareMessage={shareMessage}
          />
        </div>
      );
    case "instagram":
      return (
        <div className="SocialMedia-Preview SocialMedia-Preview-Instagram" key={category}>
          <InstagramPreview
            mediaRef={mediaRef}
            showVideoInfo={showVideoInfo}
            onShowVideoInfo={handleShowVideoInfo}
            onPlay={handlePlay}
            imageUrl={imageUrl}
            profile={profile}
            story={story}
            shareMessage={shareMessage}
          />
        </div>
      );
    case "linkedin":
      return (
        <div className="SocialMedia-Preview" key={category}>
          <LinkedinPreview
            mediaRef={mediaRef}
            showVideoInfo={showVideoInfo}
            onShowVideoInfo={handleShowVideoInfo}
            onPlay={handlePlay}
            imageUrl={imageUrl}
            profile={profile}
            story={story}
            shareMessage={shareMessage}
          />
        </div>
      );
    case "tiktok":
      return (
        <div className="SocialMedia-Preview SocialMedia-Preview-Tiktok" key={category}>
          <TiktokPreview
            mediaRef={mediaRef}
            showVideoInfo={showVideoInfo}
            onShowVideoInfo={handleShowVideoInfo}
            onPlay={handlePlay}
            imageUrl={imageUrl}
            profile={profile}
            story={story}
            shareMessage={shareMessage}
            username={username}
          />
        </div>
      );
    case "Twitter":
      break;
    default:
      break;
  }

  return <></>;
};

export default SocialMediaPreviewCard;
